<template>
  <div class="container">
    <div class="stars">
      <IconBigStar
        v-for="star in 5"
        :key="star"
        :is-filled="getFilledValue(star)"
        @click="setValue(star)"
      />
    </div>
  </div>
</template>

<script>
import IconBigStar from "@/components/icons/IconBigStar";

export default {
  name: "InputStar",
  components: {
    IconBigStar,
  },
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value: 0,
    };
  },
  methods: {
    getFilledValue(value) {
      return this.value >= value;
    },
    setValue(value) {
      this.value = value;
      this.$emit("update:value", value);
    },
  },
  mounted() {
    this.value = this.modelValue;
  },
  watch: {
    modelValue: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  .stars {
    display: flex;
    align-items: center;
  }

  svg {
    cursor: pointer;
  }
}
</style>
